// Spanish content - LITERAL, must not be modified.
export const es = {
  meta: {
    languageName: 'Español',
  },
  nav: {
    home: 'Inicio',
    services: 'Servicios',
    cardio: 'Valoración cardiometabólica estructurada',
    adiposity: 'Valoración de adiposidad y metabolismo',
    diabetes: 'Valoración integral de diabetes tipo 2',
    senior: 'Valoración Senior Saludable',
    rehab: 'Rehabilitación funcional Senior Saludable',
    family: 'Medicina de familia VIDAT',
    about: 'Sobre VIDAT',
    book: 'Programar visita',
    cta: 'Unirme a la lista',
  },
  brand: {
    name: 'VIDAT',
    tagline: 'Instituto de Inteligencia Médica',
    location: 'Sant Cugat del Vallès',
  },
  seo: {
    '/': {
      title: 'Vidat | Medicina preventiva en Sant Cugat del Vallès',
      description: 'Centro privado de medicina preventiva en Sant Cugat. Valoraciones médicas estructuradas para entender tu salud y tomar decisiones con criterio.',
    },
    '/valoracion-cardiometabolica': {
      title: 'Valoración cardiometabólica | Vidat, Sant Cugat',
      description: 'Valoración cardiometabólica estructurada en Vidat (Sant Cugat). Analítica inmediata, exploración clínica y plan preventivo para cuidar tu corazón.',
    },
    '/valoracion-adiposidad-metabolismo': {
      title: 'Adiposidad y metabolismo | Vidat, Sant Cugat',
      description: 'Valoración médica de adiposidad y salud metabólica en Vidat (Sant Cugat). Una mirada integral más allá de la báscula con resultados inmediatos.',
    },
    '/valoracion-diabetes-tipo-2': {
      title: 'Diabetes tipo 2 | Valoración integral | Vidat Sant Cugat',
      description: 'Valoración integral de diabetes tipo 2 en Vidat (Sant Cugat). Control metabólico, tratamiento y plan preventivo en una misma consulta médica.',
    },
    '/senior-saludable': {
      title: 'Valoración Senior Saludable | Vidat Sant Cugat',
      description: 'Valoración Senior Saludable en Vidat (Sant Cugat). Visión médica integral del envejecimiento: prevención funcional, cognitiva y cardiovascular.',
    },
    '/rehabilitacion-funcional': {
      title: 'Rehabilitación funcional Senior | Vidat Sant Cugat',
      description: 'Rehabilitación funcional Senior Saludable en Vidat (Sant Cugat). Recupera movilidad, fuerza y autonomía con un plan médico totalmente personalizado.',
    },
    '/medicina-de-familia': {
      title: 'Medicina de familia Vidat | Sant Cugat del Vallès',
      description: 'Medicina de familia VIDAT en Sant Cugat del Vallès. Consulta médica cercana, longitudinal y preventiva para acompañarte en cada etapa de tu salud.',
    },
    '/sobre-vidat': {
      title: 'Sobre Vidat | Instituto médico en Sant Cugat',
      description: 'Conoce VIDAT, instituto de inteligencia médica en Sant Cugat. Medicina preventiva con dirección clínica y de datos para una atención clara y rigurosa.',
    },
    '/programar-visita': {
      title: 'Programar visita | Vidat, Sant Cugat del Vallès',
      description: 'Apúntate a la lista de espera de Vidat (Sant Cugat) y te avisaremos cuando abramos agenda de primeras valoraciones de medicina preventiva estructurada.',
    },
    '/politica-de-privacidad': {
      title: 'Política de privacidad | Vidat Sant Cugat',
      description: 'Política de privacidad de Vidat, instituto médico en Sant Cugat. Información sobre el tratamiento de datos personales y derechos RGPD del usuario.',
    },
    '/politica-de-cookies': {
      title: 'Política de cookies | Vidat Sant Cugat',
      description: 'Política de cookies de Vidat (Sant Cugat). Información sobre cookies propias y de terceros utilizadas en la web y opciones de configuración.',
    },
    '/aviso-legal': {
      title: 'Aviso legal | Vidat, Sant Cugat del Vallès',
      description: 'Aviso legal de Vidat Instituto de Inteligencia Médica, S.L. Información corporativa, datos de contacto y condiciones de uso del sitio web vidat.cat.',
    },
  },
  buttons: {
    joinList: 'Unirme a la lista',
    joinFirstAssessments: 'Unirme a la lista de primeras valoraciones',
    seeCardio: 'Ver valoración cardiometabólica',
    seeAdiposity: 'Ver valoración de adiposidad y metabolismo',
    seeDiabetes: 'Ver valoración integral de diabetes tipo 2',
    expandInfo: 'Ampliar información',
    expandRehab: 'Ampliar información rehabilitación funcional',
    bookVisit: 'Programar visita',
  },
  form: {
    name: 'Nombre',
    email: 'Email',
    phone: 'Teléfono (opcional)',
    service: 'Servicio de interés',
    selectService: 'Seleccionar servicio',
    submit: 'Unirme a la lista',
    submitting: 'Enviando…',
    success: 'Te avisaremos cuando abramos agenda. Gracias.',
    error: 'No se pudo enviar la solicitud. Inténtalo de nuevo.',
    services: {
      cardio: 'Valoración Cardiometabólica',
      adiposity: 'Valoración de adiposidad y metabolismo',
      diabetes: 'Valoración integral de diabetes tipo 2',
      senior: 'Valoración Senior Saludable',
      rehab: 'Rehabilitación Funcional',
      family: 'Medicina de Familia',
      undecided: 'Aún no lo tengo claro',
    },
  },
  location: {
    eyebrow: 'Nuestra ubicación',
    title: 'Sant Cugat del Vallès',
    address: 'Local 6, Carrer de Pau Muñoz i Castanyer, 12, 08174 Sant Cugat del Vallès, Barcelona',
    description: 'Un entorno bien comunicado, pensado para facilitar el acceso a personas que valoran una atención médica estructurada, eficiente y sin desplazamientos innecesarios.',
    notify: 'Te avisaremos cuando abramos agenda para las primeras valoraciones.',
    homeIntro1: 'Estamos en Sant Cugat del Vallès.',
    homeIntro2: 'Puedes consultar la ubicación del centro en Google Maps.',
    mapLabel: 'Ver en Google Maps',
    mapButton: 'Ver ubicación en Google Maps',
    placeholderExterior: 'Fotografía exterior del edificio (próximamente)',
    placeholderInterior: 'Fotografía del interior de VIDAT (próximamente)',
  },
  footer: {
    tagline: 'Medicina preventiva para entender mejor tu salud.',
    sections: 'Servicios',
    institute: 'Instituto',
    contact: 'Contacto',
    follow: 'Síguenos',
    rights: 'Todos los derechos reservados.',
    notice: 'Comunicación sanitaria con carácter informativo. No constituye consejo médico individualizado.',
  },
  home: {
    eyebrow: 'VIDAT — Instituto de Inteligencia Médica',
    location: 'Sant Cugat del Vallès',
    headline: 'Medicina preventiva para entender mejor tu salud y actuar con criterio',
    intro1: 'En VIDAT realizamos valoraciones médicas estructuradas que integran datos clínicos, hábitos, exploración y resultados inmediatos para ayudarte a comprender tu salud de forma clara y tomar mejores decisiones.',
    intro2: 'Nuestro primer objetivo es que salgas de la consulta con una visión ordenada de tu situación, una explicación comprensible de tus resultados y un plan de acción inicial adaptado a tu caso.',
    differential: {
      eyebrow: 'Una forma diferente de trabajar',
      title: 'Una forma más clara de entender la salud',
      p1: 'En muchas consultas, la información se revisa de forma separada: una analítica por un lado, la tensión arterial por otro, los antecedentes en otro momento y los hábitos de vida como una conversación aislada.',
      p2: 'En VIDAT trabajamos de otra forma.',
      highlight: 'Integración clínica de todos los datos',
      p3: 'Integramos la información clínica relevante en una misma valoración para entender qué factores tienen más peso, cómo se relacionan entre sí y qué prioridades conviene abordar primero.',
      p4: 'Esto permite al médico diseñar un plan de acción con todos los datos disponibles en la misma visita.',
      p5: 'No se trata solo de obtener datos.',
      p6: 'Se trata de interpretarlos en contexto y transformarlos en una orientación médica clara.',
    },
    cardioBlock: {
      eyebrow: 'Valoración cardiometabólica estructurada',
      title: 'Comprende tu estado cardiovascular real en una sola visita',
      lead: 'Una evaluación médica completa para valorar y entender tu riesgo cardiometabólico, incluso antes de que aparezcan síntomas.',
      audience: 'Está pensada para personas que quieren tener una visión clara de su salud cardiovascular, especialmente si tienen perfiles de alta responsabilidad, agendas exigentes, antecedentes familiares cardiovasculares, colesterol, glucosa o tensión en seguimiento, o si buscan una prevención más estructurada que una revisión aislada.',
      includesTitle: 'Qué incluye la valoración',
      includesIntro: 'Realizamos una valoración estructurada en un único acto médico que incluye:',
      include1Title: 'Historia clínica detallada',
      include1Body: 'hábitos, antecedentes personales y familiares, medicación y factores de riesgo.',
      include2Title: 'Exploración clínica',
      include2Body: 'tensión arterial, composición corporal y medidas antropométricas.',
      include3Title: 'Analítica inmediata',
      include3Body: 'glucosa, perfil lipídico y hemoglobina glicosilada mediante muestra capilar.',
      processing: 'Todos los resultados se procesan en consulta mediante un sistema de Business Intelligence que permite visualizar y relacionar los parámetros de forma conjunta y en tiempo real.',
      processing2: 'Esto permite interpretar los resultados en un contexto global, identificar los factores de mayor impacto y diseñar un plan de acción con todos los datos disponibles en la misma visita.',
      modelEyebrow: 'Un modelo eficiente de medicina preventiva',
      modelHighlight: 'Una sola visita para transformar datos clínicos dispersos en resultados comprensibles y un plan de acción personalizado.',
      whatYouGetTitle: 'Qué obtienes al finalizar',
      get1: 'Una visión clara y gráfica de tu riesgo cardiovascular.',
      get2: 'Comprensión de los factores específicos que lo determinan.',
      get3: 'Estimación del riesgo cardiovascular a 10 años.',
      get4: 'Identificación de prioridades de intervención personalizadas.',
      get5: 'Un plan de acción inicial explicado de forma estructurada y comprensible.',
    },
    seniorBridge: {
      eyebrow: 'Y cuando la preocupación no eres solo tú',
      p1: 'Muchas personas empiezan a cuidar mejor su salud justo cuando también empiezan a preocuparse por la salud de sus padres.',
      p2: 'Cuando una persona mayor empieza a perder fuerza, moverse con menos seguridad o mostrar cambios en su autonomía diaria, puede ser buen momento para realizar una valoración médica y funcional más completa.',
      p3: 'Por eso en VIDAT también hemos desarrollado la consulta Valoración Senior Saludable.',
    },
    seniorBlock: {
      eyebrow: 'Valoración Senior Saludable',
      title: 'Una valoración médica y funcional para cuidar autonomía, movilidad y calidad de vida',
      p1: 'La Valoración Senior Saludable está pensada para personas mayores que necesitan una valoración global, ordenada y práctica de su estado de salud.',
      p2: 'Evaluamos antecedentes médicos, medicación, independencia en actividades diarias, movilidad, equilibrio, riesgo de caídas, estado nutricional y cognición.',
      p3: 'El objetivo es detectar áreas de fragilidad o vulnerabilidad de forma precoz y orientar un plan de cuidado personalizado.',
      p4: 'Puede ser especialmente útil cuando notas que tu padre, madre o abuelo empieza a perder fuerza, se mueve con más inestabilidad, ha tenido alguna caída o presenta cambios en su alimentación. También cuando necesitáis una valoración médica más completa para entender mejor cómo está y qué conviene hacer.',
    },
    rehabBlock: {
      eyebrow: 'Rehabilitación funcional Senior Saludable',
      p1: 'Cuando la valoración lo indica, el siguiente paso puede ser trabajar fuerza, equilibrio y movilidad de forma supervisada.',
      p2: 'En VIDAT, la rehabilitación funcional puede realizarse de forma individual o en grupos reducidos, según las necesidades, el nivel funcional y los objetivos de cada persona.',
      p3: 'Está pensada para adultos mayores que necesitan moverse con más seguridad, recuperar confianza y mantener independencia en las actividades del día a día.',
      p4: 'Antes de iniciar el programa, se realiza una valoración funcional previa para adaptar el trabajo al nivel de cada persona y definir si el abordaje más adecuado es individual, grupal o combinado.',
      p5: 'El objetivo no es solo hacer ejercicio, sino preservar autonomía, reducir vulnerabilidad funcional y acompañar a la persona mayor en un proceso seguro y progresivo.',
    },
    twoMoments: {
      title: 'VIDAT nace para cuidar dos momentos clave',
      moment1: 'Cuando aún estás a tiempo de reducir riesgos.',
      moment2: 'Y cuando mantener la autonomía empieza a ser lo más importante.',
    },
  },
  cardio: {
    eyebrow: 'Valoración Cardiometabólica Estructurada',
    title: 'Comprende tu estado cardiovascular real en una sola visita',
    lead: 'Una evaluación médica completa para valorar y entender tu riesgo cardiometabólico, incluso antes de que aparezcan síntomas.',
    forWhomTitle: 'Para quién es esta evaluación',
    forWhomLead: 'Dirigido a personas que quieren tener una visión clara de su salud cardiovascular:',
    forWhom: [
      'Personas con perfiles de alta responsabilidad y agendas exigentes que valoran la eficiencia.',
      'Personas con antecedentes familiares cardiovasculares.',
      'Pacientes con colesterol, glucosa o tensión en seguimiento.',
      'Personas que buscan prevención real, no solo revisiones aisladas.',
    ],
    problemTitle: 'El problema habitual',
    problemP1: 'En la práctica clínica convencional, los datos se obtienen de forma fragmentada: análisis por un lado, exploración por otro y resultados en momentos diferentes, sin una visión global inmediata.',
    problemP2: 'Esto dificulta entender el riesgo real en el momento de la consulta.',
    evalTitle: 'Evaluación completa en una sola visita',
    evalLead: 'Realizamos una valoración estructurada en un único acto médico que incluye:',
    eval: [
      ['Historia clínica detallada', 'hábitos, antecedentes y factores de riesgo.'],
      ['Exploración clínica', 'tensión, composición corporal y medidas antropométricas.'],
      ['Analítica inmediata', 'glucosa, perfil lipídico y hemoglobina glicosilada mediante muestra capilar.'],
    ],
    integrationTitle: 'Integración clínica de todos los datos',
    integrationP1: 'Todos los resultados se procesan en consulta mediante un sistema de Business Intelligence que permite visualizar y relacionar todos los parámetros de forma conjunta y en tiempo real.',
    integrationP2: 'Esto permite al médico:',
    integrationList: [
      'Interpretar los resultados en un contexto global e inmediato.',
      'Identificar los factores de mayor impacto mediante la relación entre datos clínicos, analíticos y de hábitos.',
      'Evitar la fragmentación de informes y la pérdida de información clave.',
      'Diseñar un plan de acción con todos los datos disponibles en la misma visita.',
    ],
    interpretationTitle: 'Interpretación médica en el momento',
    interpretationP1: 'La evaluación es interpretada directamente por el médico a través de un dashboard interactivo durante la consulta.',
    interpretationP2: 'Se obtiene:',
    interpretationList: [
      'Estimación del riesgo cardiovascular a 10 años.',
      'Comprensión clara del estado metabólico actual.',
      'Identificación de los factores principales de riesgo mediante visualización de datos.',
      'Explicación estructurada, visual y comprensible para el paciente.',
    ],
    obtainTitle: 'Qué obtienes al finalizar',
    obtain: [
      'Una visión clara y gráfica de tu riesgo cardiovascular.',
      'Comprensión de los factores específicos que lo determinan.',
      'Prioridades de intervención personalizadas y plan de acción inicial.',
    ],
    modelEyebrow: 'Un modelo eficiente de medicina preventiva',
    modelHighlight: 'Una sola visita para transformar datos clínicos dispersos en resultados comprensibles y un plan de acción personalizado.',
  },
  senior: {
    eyebrow: 'Valoración Senior Saludable',
    title: 'Una valoración médica y funcional para cuidar autonomía, movilidad y calidad de vida',
    lead: 'Una evaluación estructurada para conocer el estado funcional de una persona senior, identificar áreas de vulnerabilidad y orientar un plan de cuidado personalizado.',
    forWhomTitle: 'Para quién es esta evaluación',
    forWhomLead: 'Dirigida a familias que quieren entender mejor el estado funcional de su padre, madre o abuelo, especialmente cuando aparecen cambios en la movilidad, la fuerza o la autonomía diaria.',
    forWhomIntro: 'Puede ser especialmente útil cuando:',
    forWhom: [
      'Una persona senior empieza a perder fuerza o moverse con más inestabilidad.',
      'Ha tenido alguna caída o tiene miedo a caerse.',
      'Camina más lento o le cuesta levantarse de una silla.',
      'Ha reducido su actividad diaria o sale menos de casa.',
      'Presenta pérdida de peso, menor apetito o cambios en su alimentación.',
      'La familia necesita entender mejor su situación y saber qué conviene hacer.',
    ],
    problemTitle: 'El problema habitual',
    problemP1: 'A menudo, los cambios en la movilidad, la fuerza o la autonomía ocurren de manera progresiva.',
    problemP2: 'Un poco menos de fuerza, algo más de inseguridad al caminar, menor apetito, una caída aislada o más dificultad para realizar actividades cotidianas pueden parecer hechos separados.',
    problemP3: 'Sin embargo, cuando se valoran en conjunto, pueden ayudar a detectar áreas de fragilidad o vulnerabilidad funcional que conviene abordar a tiempo.',
    evalTitle: 'Evaluación médica y funcional en una sola visita',
    evalLead: 'Realizamos una valoración estructurada en un único acto médico que incluye:',
    eval: [
      ['Historia clínica y contexto personal', 'antecedentes médicos, medicación, caídas recientes, hábitos de actividad, alimentación, convivencia y red de apoyo.'],
      ['Autonomía y funcionalidad', 'valoración de independencia en actividades básicas e instrumentales de la vida diaria.'],
      ['Movilidad, equilibrio y fuerza', 'pruebas funcionales para valorar marcha, estabilidad, fuerza de miembros inferiores y fuerza muscular global.'],
      ['Nutrición y cognición breve', 'cribado nutricional, cambios de peso o apetito, y valoración cognitiva breve cuando procede.'],
    ],
    integrationTitle: 'Integración funcional de todos los datos',
    integrationP1: 'Todos los resultados se analizan de forma conjunta para entender no solo si existe una limitación, sino qué áreas están conservadas, cuáles empiezan a mostrar vulnerabilidad y qué prioridades conviene trabajar primero.',
    integrationP2: 'Esto permite al médico:',
    integrationList: [
      'Valorar el estado de autonomía, movilidad, fuerza, nutrición y cognición breve.',
      'Identificar riesgo de caídas, fragilidad o pérdida funcional incipiente.',
      'Relacionar los resultados de las pruebas con la situación real del día a día.',
      'Diseñar un plan de trabajo adaptado al nivel funcional de cada persona.',
    ],
    interpretationTitle: 'Interpretación médica en el momento',
    interpretationP1: 'La evaluación es interpretada directamente por el médico durante la consulta y se explica de forma clara al paciente y, si procede, a su familia.',
    interpretationP2: 'Se obtiene:',
    interpretationList: [
      'Clasificación del perfil funcional actual.',
      'Valoración del riesgo de caídas.',
      'Identificación de áreas conservadas y áreas vulnerables.',
      'Orientación sobre nutrición, fuerza, movilidad y autonomía.',
      'Recomendaciones iniciales y necesidad o no de seguimiento.',
    ],
    obtainTitle: 'Qué obtienes al finalizar',
    obtain: [
      'Una visión clara del estado funcional de la persona senior.',
      'Comprensión de qué aspectos están bien y cuáles conviene vigilar.',
      'Identificación de prioridades de mejora.',
      'Un plan de cuidado personalizado, realista y adaptado a su situación.',
      'Orientación sobre si puede beneficiarse de seguimiento médico, apoyo nutricional o rehabilitación funcional.',
    ],
    modelEyebrow: 'Un modelo preventivo para envejecer con más autonomía',
    modelHighlight: 'Envejecer bien no es solo no tener enfermedades. También es conservar fuerza, movilidad, equilibrio, nutrición adecuada, seguridad al caminar y capacidad para seguir haciendo las actividades importantes de la vida diaria.',
    modelOutro: 'La Valoración Senior Saludable transforma información médica y funcional dispersa en una explicación clara y un plan de acción humano, progresivo y medible.',
    rehabTitle: 'Rehabilitación funcional y seguimiento',
    rehabP1: 'Cuando la valoración lo indica, el siguiente paso puede ser trabajar fuerza, equilibrio y movilidad de forma supervisada.',
    rehabP2: 'En VIDAT, la rehabilitación funcional puede realizarse de forma individual o en grupos reducidos, según las necesidades, el nivel funcional y los objetivos de cada persona.',
    rehabP3: 'El seguimiento puede incluir reevaluación funcional, seguimiento nutricional o revisión médica evolutiva para ajustar el plan según la evolución.',
  },
  rehab: {
    eyebrow: 'Rehabilitación funcional individual y grupal',
    title: 'Fuerza, equilibrio y movilidad para mantener autonomía en el día a día',
    lead: 'Un programa de ejercicio terapéutico supervisado, orientado a personas que necesitan mejorar o mantener su capacidad funcional, moverse con más seguridad y conservar independencia en sus actividades habituales.',
    lead2: 'Puede realizarse de forma individual o en grupos reducidos, según el nivel funcional, las necesidades clínicas y los objetivos de cada persona.',
    forWhomTitle: 'Para quién es este programa',
    forWhomLead: 'Dirigido a familias que buscan una intervención funcional estructurada para su padre, madre o abuelo.',
    forWhomIntro: 'Puede ser especialmente útil cuando:',
    forWhom: [
      'Empieza a perder fuerza o moverse con más inseguridad.',
      'Le cuesta levantarse de una silla, caminar distancias habituales o subir escaleras.',
      'Ha tenido alguna caída o tiene miedo a caerse.',
      'Camina más lento o ha reducido su actividad diaria.',
      'Presenta prefragilidad, fragilidad leve o pérdida funcional incipiente.',
      'Necesita recuperar confianza para moverse con más seguridad.',
    ],
    forWhomOutro: 'También puede estar indicado después de una Valoración Senior Saludable, cuando se identifican áreas de mejora en fuerza, equilibrio, movilidad, marcha o riesgo de caídas.',
    problemTitle: 'El problema habitual',
    problemP1: 'A menudo, la pérdida de movilidad no aparece de golpe.',
    problemP2: 'Empieza con pequeños cambios: caminar menos, levantarse con más dificultad, evitar escaleras, sentirse inseguro al salir o necesitar más ayuda para actividades que antes hacía sin esfuerzo.',
    problemP3: 'Si estos cambios no se valoran ni se trabajan de forma adecuada, pueden favorecer más sedentarismo, pérdida de fuerza y reducción progresiva de autonomía.',
    problemP4: 'Por eso, el ejercicio terapéutico debe ser seguro, progresivo y adaptado al nivel real de cada persona.',
    valTitle: 'Valoración funcional antes de empezar',
    valP1: 'Antes de iniciar el programa, realizamos una valoración funcional inicial para conocer el punto de partida y definir el abordaje más adecuado.',
    valP2: 'Esta valoración permite:',
    valList: [
      'Conocer el nivel funcional: movilidad, fuerza, equilibrio, marcha y tolerancia al esfuerzo.',
      'Identificar factores de riesgo: caídas previas, miedo a caer, inestabilidad o uso de ayudas técnicas.',
      'Asignar el formato más adecuado: intervención individual, grupo reducido o abordaje combinado.',
    ],
    valOutro: 'Las personas que hayan realizado recientemente la Valoración Senior Saludable podrán incorporarse al programa sin repetir esta valoración inicial, siempre que no hayan aparecido cambios clínicos relevantes.',
    adaptTitle: 'Un programa adaptado al nivel de cada persona',
    adaptP1: 'El programa no se plantea como una clase colectiva genérica.',
    adaptP2: 'Cada persona se incorpora según su situación funcional, sus objetivos y su necesidad de supervisión.',
    adaptP3: 'Puede realizarse en dos modalidades:',
    adaptModes: [
      ['Rehabilitación funcional individual', 'indicada cuando la persona necesita una supervisión más estrecha, presenta mayor fragilidad, inseguridad, dolor, limitaciones específicas o requiere un trabajo más personalizado.'],
      ['Rehabilitación funcional en grupos reducidos', 'indicada cuando la persona puede beneficiarse de un entorno supervisado, motivador y adaptado, con ejercicios ajustados a su nivel funcional.'],
    ],
    adaptOutro: 'Los grupos son reducidos para permitir una atención cercana, progresión segura y adaptación individual dentro de cada sesión.',
    workTitle: 'Qué se trabaja durante las sesiones',
    workP1: 'Las sesiones combinan ejercicio terapéutico multicomponente, guiado por fisioterapeuta, con trabajo de fuerza, equilibrio, movilidad, marcha y resistencia funcional.',
    workP2: 'Incluyen:',
    workList: [
      ['Fuerza funcional', 'levantarse y sentarse, trabajo de piernas, tronco y brazos con ejercicios adaptados.'],
      ['Equilibrio y seguridad', 'cambios de peso, estabilidad, control postural, giros y apoyo seguro.'],
      ['Marcha y movilidad', 'caminar con más seguridad, cambiar de dirección, mejorar ritmo, tolerancia y confianza.'],
      ['Resistencia funcional', 'ejercicios de baja carga para mejorar la tolerancia al esfuerzo.'],
      ['Movimientos útiles para la vida diaria', 'levantarse, girar, subir un escalón, alcanzar objetos o desplazarse con más seguridad.'],
    ],
    workHighlight: 'El objetivo no es hacer ejercicio sin más, sino entrenar capacidades directamente relacionadas con la autonomía cotidiana.',
    followTitle: 'Seguimiento de la evolución',
    followP1: 'El programa se organiza en ciclos de trabajo, con seguimiento de la evolución funcional mediante pruebas sencillas y comparables en el tiempo.',
    followP2: 'Esto permite:',
    followList: [
      'Valorar cambios en fuerza, movilidad, equilibrio y marcha.',
      'Ajustar la intensidad y el tipo de ejercicios.',
      'Revisar si el grupo o modalidad sigue siendo el más adecuado.',
      'Detectar nuevas necesidades de seguimiento médico, nutricional o funcional.',
    ],
    followOutro: 'La evolución no se basa solo en sensaciones. Se acompaña de indicadores funcionales que ayudan a entender si la persona mejora, se mantiene o necesita ajustar el plan.',
    obtainTitle: 'Qué obtienes al iniciar el programa',
    obtain: [
      'Una valoración funcional inicial para conocer el punto de partida.',
      'Un plan de trabajo adaptado al nivel funcional de la persona.',
      'Sesiones supervisadas por fisioterapeuta.',
      'Trabajo específico de fuerza, equilibrio, movilidad y marcha.',
      'Seguimiento de la evolución funcional.',
      'Orientación sobre la modalidad más adecuada: individual, grupal o combinada.',
    ],
    modelTitle: 'Un modelo funcional, seguro y medible',
    modelP1: 'La rehabilitación funcional de VIDAT está pensada para acompañar a personas que quieren mantener autonomía, moverse con más seguridad y preservar su capacidad para realizar las actividades importantes de la vida diaria.',
    modelP2: 'Una intervención estructurada para transformar la pérdida de fuerza, la inseguridad al caminar o la reducción de actividad en un plan de trabajo progresivo, supervisado y adaptado a cada persona.',
    integratedTitle: 'Integrado dentro del enfoque Senior Saludable',
    integratedP1: 'Este programa puede ser el siguiente paso tras la Valoración Senior Saludable, especialmente cuando se detectan áreas de mejora en movilidad, fuerza, equilibrio o riesgo de caídas.',
    integratedP2: 'También puede iniciarse de forma independiente, siempre con una valoración funcional previa que permita trabajar con seguridad y adaptar el programa desde el primer día.',
  },
  family: {
    eyebrow: 'Medicina de Familia VIDAT',
    title: 'Una consulta médica cercana, resolutiva y con visión global',
    lead: 'Atención médica para valorar síntomas, revisar problemas de salud frecuentes, interpretar resultados y orientar decisiones clínicas con criterio.',
    lead2: 'En VIDAT, la medicina de familia no se plantea como una visita rápida y aislada, sino como una consulta estructurada para entender el contexto completo de cada persona.',
    forWhomTitle: 'Para quién es esta consulta',
    forWhomLead: 'Dirigida a personas que buscan una atención médica clara, eficiente y de confianza.',
    forWhomIntro: 'Puede ser especialmente útil para:',
    forWhom: [
      'Personas con agendas exigentes que necesitan una valoración médica resolutiva.',
      'Pacientes que quieren consultar síntomas recientes o persistentes.',
      'Personas que necesitan interpretar resultados, informes o recomendaciones previas.',
      'Pacientes que buscan una segunda mirada clínica antes de decidir los siguientes pasos.',
      'Personas que desean una consulta médica general con más tiempo, orden y continuidad.',
    ],
    problemTitle: 'El problema habitual',
    problemP1: 'En muchas ocasiones, la atención médica se vive de forma fragmentada.',
    problemP2: 'Una consulta por un síntoma, otra por una analítica, otra por una receta, otra por una derivación. Con frecuencia, el paciente acaba acumulando informes, resultados y recomendaciones sin una visión médica suficientemente integrada.',
    problemP3: 'Esto puede dificultar entender qué es prioritario, qué puede esperar, qué requiere seguimiento y qué decisiones conviene tomar.',
    consultTitle: 'Consulta médica con visión integral',
    consultP1: 'Realizamos una valoración médica orientada a comprender el motivo de consulta y el contexto general de salud.',
    consultP2: 'La consulta puede incluir:',
    consultList: [
      ['Valoración clínica del problema actual', 'síntomas, evolución, antecedentes relevantes y exploración dirigida.'],
      ['Revisión de información médica disponible', 'informes, analíticas, pruebas previas, tratamientos y recomendaciones recibidas.'],
      ['Orientación diagnóstica y plan inicial', 'recomendaciones, ajuste de tratamiento cuando procede, solicitud de pruebas o derivación si es necesario.'],
    ],
    consultOutro: 'El objetivo es que la persona entienda qué está ocurriendo, qué nivel de importancia tiene y cuáles son los siguientes pasos razonables.',
    integrationTitle: 'Integración clínica de la información',
    integrationP1: 'En VIDAT damos importancia a revisar la información médica de forma ordenada.',
    integrationP2: 'Esto permite al médico:',
    integrationList: [
      'Interpretar síntomas, informes y resultados dentro del contexto global de la persona.',
      'Diferenciar problemas urgentes, importantes y situaciones que pueden seguirse de forma programada.',
      'Evitar decisiones basadas en datos aislados.',
      'Diseñar un plan de seguimiento claro y adaptado al caso.',
    ],
    integrationOutro: 'La consulta no se centra solo en resolver una duda puntual, sino en entender cómo esa duda encaja dentro de la salud general del paciente.',
    followTitle: 'Seguimiento médico y continuidad',
    followP1: 'La medicina de familia permite acompañar problemas frecuentes de salud de forma longitudinal.',
    followP2: 'Puede incluir:',
    followList: [
      'Valoración de síntomas recientes o persistentes.',
      'Revisión y ajuste de tratamientos cuando procede.',
      'Interpretación de informes, analíticas o pruebas complementarias.',
      'Seguimiento de problemas médicos habituales.',
      'Coordinación con otros especialistas si es necesario.',
      'Orientación sobre cuándo observar, cuándo tratar y cuándo ampliar estudio.',
    ],
    followOutro: 'La continuidad permite detectar cambios, ordenar decisiones y mantener una visión más completa de la evolución clínica.',
    obtainTitle: 'Qué obtienes al finalizar',
    obtain: [
      'Una valoración médica clara del motivo de consulta.',
      'Explicación comprensible de los hallazgos y resultados disponibles.',
      'Orientación sobre el nivel de importancia del problema.',
      'Recomendaciones iniciales y plan de actuación.',
      'Indicación de pruebas, seguimiento o derivación si procede.',
      'Una visión médica global, no solo una respuesta aislada.',
    ],
    modelEyebrow: 'Una medicina de familia pensada para personas que valoran su tiempo',
    modelP1: 'Una consulta para entender mejor qué ocurre, ordenar la información médica disponible y definir los siguientes pasos con criterio clínico.',
    modelP2: 'Atención médica cercana, estructurada y resolutiva para quienes buscan confianza, claridad y continuidad.',
  },
  about: {
    eyebrow: 'Sobre VIDAT',
    title: 'Un proyecto médico construido desde la clínica, la gestión y los datos',
    p1: 'VIDAT nace como un centro de medicina preventiva orientado a ofrecer valoraciones médicas más estructuradas, comprensibles y útiles para el paciente.',
    p2: 'Nuestro enfoque combina experiencia clínica, análisis de datos, organización asistencial y una forma clara de comunicar los resultados.',
    p3: 'El objetivo es que cada persona entienda mejor su situación de salud y pueda tomar decisiones con una orientación médica clara, realista y personalizada.',
    teamEyebrow: 'Equipo fundador',
    team: [
      {
        name: 'Dra. Inés Betancourt Torres',
        role: 'Dirección médica',
        bio: [
          'Médico especialista vía MIR en Medicina Familiar y Comunitaria, con más de 14 años de experiencia médica y formación específica en diabetes tipo 2, prevención cardiometabólica, atención a la cronicidad, geriatría e innovación sanitaria.',
          'Cuenta con un Máster en Atención y Educación a las Personas con Diabetes por la Universidad Francisco de Vitoria y la Fundación redGDPS, formación especialmente alineada con la valoración cardiometabólica, el seguimiento de factores de riesgo y la educación sanitaria del paciente.',
          'Ha desarrollado su actividad asistencial en atención primaria, consulta privada en Sant Cugat del Vallès, urgencias hospitalarias, telemedicina y geriatría.',
          'En el ámbito del envejecimiento saludable, cuenta con experiencia en valoración geriátrica integral, seguimiento de pacientes con comorbilidad, ortogeriatría y continuidad asistencial; competencias directamente relacionadas con la Valoración Senior Saludable y los programas funcionales de VIDAT.',
          'También ha realizado formación de posgrado como Experta en Productos Sanitarios por la Universitat de Barcelona y ha participado como cofundadora y directora médica de Clarity Stethoscope.',
          'En VIDAT lidera el diseño clínico de las valoraciones médicas, la atención asistencial y la coordinación del modelo preventivo del centro, integrando medicina de familia, prevención cardiometabólica y envejecimiento saludable.',
        ],
      },
      {
        name: 'Jacqueline Torres Castillo',
        role: 'Dirección de administración, operaciones y experiencia del centro',
        bio: [
          'Administradora de empresas, con formación complementaria en diseño y gestión administrativa, y experiencia en dirección ejecutiva, desarrollo de proyectos y organización de iniciativas empresariales.',
          'Ha sido CEO de Clarity Stethoscope, una startup de innovación médica en patología respiratoria desarrollada en Barcelona, orientada a mejorar el seguimiento de enfermedades respiratorias mediante tecnología accesible y confiable. Desde esa posición, ha participado en la coordinación estratégica y operativa de un proyecto healthtech con componente clínico, tecnológico, científico y de comunicación.',
          'Durante su etapa en Clarity Stethoscope, el proyecto participó en programas, aceleradoras, congresos y espacios de innovación sanitaria, y obtuvo distintos reconocimientos vinculados al ecosistema emprendedor y de salud digital en Cataluña. Esta experiencia le ha permitido trabajar en áreas clave para VIDAT: dirección de proyecto, gestión de recursos, relación con colaboradores, comunicación, desarrollo de marca y organización operativa.',
          'En VIDAT coordina el área administrativa, la experiencia del paciente y el funcionamiento interno del centro.',
          'Su papel es garantizar que cada proceso —desde el primer contacto hasta la atención en consulta— sea claro, ordenado y coherente con la filosofía de VIDAT: una medicina estructurada, cercana y eficiente.',
        ],
      },
      {
        name: 'Patricia Peña Torres',
        role: 'Dirección de datos, visualización clínica e innovación tecnológica',
        bio: [
          'Científica de datos y consultora en Business Intelligence, con formación en sociología, inteligencia de negocio y gestión de datos.',
          'Su experiencia profesional se ha desarrollado en análisis de información, procesos ETL, reporting, visualización de datos, definición de indicadores y construcción de soluciones analíticas para apoyar la toma de decisiones.',
          'Ha sido CTO de Clarity Stethoscope, proyecto healthtech orientado al análisis de sonidos respiratorios y al desarrollo de herramientas digitales para mejorar el seguimiento clínico de pacientes respiratorios. En este contexto ha participado en el diseño tecnológico del proyecto, la estructuración de datos clínicos y el desarrollo de modelos de análisis aplicados a señales biomédicas.',
          'También ha participado en investigación aplicada en salud digital, incluyendo trabajos presentados en el European Respiratory Society International Congress, con publicaciones sobre clasificación de sonidos respiratorios mediante algoritmos de machine learning.',
          'En VIDAT lidera el área de datos, visualización clínica y soporte tecnológico.',
          'Su trabajo permite reforzar uno de los elementos diferenciales del centro: convertir datos clínicos, hábitos, exploración y resultados inmediatos en una visión integrada, visual y comprensible durante la consulta.',
        ],
      },
    ],
    collabTitle: 'Equipo clínico colaborador',
    collabP1: 'VIDAT incorporará progresivamente profesionales sanitarios colaboradores alineados con el enfoque del centro.',
    collabP2: 'El objetivo es contar con un equipo clínico coordinado, capaz de acompañar distintas áreas de prevención, seguimiento y cuidado funcional.',
    collabIntro: 'Entre los perfiles previstos se incluyen:',
    collabList: [
      'Médicos colaboradores.',
      'Fisioterapeutas.',
      'Nutricionistas.',
      'Psicólogos.',
      'Otros profesionales sanitarios vinculados al cuidado preventivo y funcional.',
    ],
    collabOutro: 'Todos los colaboradores trabajarán bajo una misma filosofía: valoración estructurada, comunicación clara, seguimiento personalizado y coordinación clínica cuando sea necesario.',
    methodTitle: 'Nuestra forma de trabajar',
    methodP1: 'En VIDAT creemos que una buena atención médica no depende solo de hacer más pruebas, sino de integrar mejor la información.',
    methodP2: 'Por eso trabajamos con una metodología basada en:',
    methodList: [
      'Escucha clínica y valoración médica rigurosa.',
      'Recogida estructurada de información.',
      'Interpretación de datos en contexto.',
      'Explicación clara de resultados.',
      'Planes de acción realistas y medibles.',
      'Coordinación entre profesionales cuando el caso lo requiere.',
    ],
    methodOutro: 'VIDAT es un centro pensado para personas que valoran una medicina clara, ordenada y orientada a decisiones.',
    visionTitle: 'Una clínica con una visión propia',
    visionP1: 'VIDAT une tres áreas que habitualmente trabajan por separado: medicina, datos y gestión.',
    visionP2: 'La dirección médica aporta el criterio clínico y la visión asistencial.',
    visionP3: 'La dirección de datos permite transformar información compleja en resultados comprensibles.',
    visionP4: 'La dirección administrativa y operativa garantiza una experiencia organizada, eficiente y coherente con el nivel de atención que queremos ofrecer.',
    visionP5: 'El resultado es un modelo de centro médico pensado para que el paciente no solo reciba información, sino que pueda entenderla y utilizarla para cuidar mejor su salud.',
  },
  book: {
    eyebrow: 'Programar visita',
    title: 'Lista de espera de primeras valoraciones',
    p1: 'VIDAT abrirá próximamente en Sant Cugat del Vallès. De momento puedes apuntarte a la lista de espera y te avisaremos cuando abramos agenda para las primeras valoraciones.',
    p2: 'Indícanos qué servicio te interesa y, si lo deseas, un teléfono de contacto. Trataremos tu información con confidencialidad.',
  },
  adiposity: {
    eyebrow: 'Valoración de adiposidad y metabolismo',
    title: 'Valoración de adiposidad y metabolismo',
    lead: 'Una valoración médica estructurada para comprender el peso, la adiposidad y la salud metabólica desde una visión clínica global.',
    homeShortTitle: 'Valoración de adiposidad y metabolismo',
    homeShortLead: 'Una valoración médica para comprender el peso, la adiposidad abdominal y los factores metabólicos que pueden influir en la salud.',
    homeShortP1: 'En VIDAT analizamos el peso dentro de un contexto clínico más amplio: antecedentes, tratamientos, hábitos de alimentación, actividad física, esfera emocional, posibles factores hormonales y parámetros metabólicos inmediatos.',
    homeShortP2: 'El objetivo es identificar qué áreas pueden estar influyendo en la salud metabólica y orientar un plan inicial realista, personalizado y medible.',
    forWhomTitle: 'Para quién es esta valoración',
    forWhomP1: 'Dirigida a personas con sobrepeso, obesidad, aumento progresivo de peso, perímetro abdominal elevado o dificultad para mejorar su composición corporal y su salud metabólica.',
    forWhomP2: 'También puede ser útil cuando existen alteraciones de glucosa, colesterol o triglicéridos, antecedentes familiares cardiometabólicos, dolor crónico que limita la actividad física, tratamientos que pueden favorecer aumento de peso o sospecha de factores hormonales asociados.',
    problemTitle: 'El problema habitual',
    problemP1: 'Con frecuencia, el peso se aborda de forma aislada, centrando la atención solo en la dieta o en la báscula.',
    problemP2: 'En VIDAT lo valoramos de forma más completa, integrando información clínica, hábitos, exploración física y parámetros metabólicos para entender qué factores pueden estar influyendo y qué prioridades conviene abordar primero.',
    includesTitle: 'Qué incluye la valoración',
    includesIntro: 'Realizamos una valoración médica estructurada que puede incluir:',
    includesList: [
      'Historia clínica, antecedentes y tratamientos habituales.',
      'Revisión de hábitos de alimentación, actividad física y contexto personal.',
      'Valoración de posibles factores hormonales, digestivos, emocionales o funcionales.',
      'Exploración clínica y antropométrica: peso, talla, tensión arterial y circunferencia abdominal.',
      'Analítica inmediata en consulta: glucosa, perfil lipídico y hemoglobina glicosilada.',
      'Interpretación visual de resultados y resumen de áreas prioritarias.',
    ],
    obtainTitle: 'Qué obtienes al finalizar',
    obtainList: [
      'Una visión médica clara de tu situación metabólica.',
      'Comprensión de los factores que pueden estar influyendo en el peso.',
      'Resultados inmediatos de parámetros metabólicos clave.',
      'Identificación de áreas prioritarias de mejora.',
      'Un plan inicial personalizado, realista y medible.',
      'Orientación sobre seguimiento médico, nutricional, psicológico, hormonal o funcional si procede.',
    ],
    closingTitle: 'Una mirada más allá de la báscula',
    closingP1: 'Comprender la adiposidad implica mirar más allá de la báscula: valorar su distribución, su contexto metabólico y los factores clínicos que pueden estar influyendo.',
    closingP2: 'La Valoración de adiposidad y metabolismo de VIDAT ayuda a ordenar esta información y convertirla en una orientación médica clara, realista y personalizada.',
  },
  diabetes: {
    eyebrow: 'Valoración integral de diabetes tipo 2',
    title: 'Valoración integral de diabetes tipo 2',
    lead: 'Una consulta médica estructurada para revisar el control metabólico, el tratamiento y el plan preventivo en diabetes tipo 2.',
    homeShortTitle: 'Valoración integral de diabetes tipo 2',
    homeShortLead: 'Una consulta médica estructurada para revisar el control metabólico, el tratamiento actual y los controles preventivos recomendados en diabetes tipo 2.',
    homeShortP1: 'Integramos datos clínicos, hábitos, exploración, resultados inmediatos y factores de riesgo cardiovascular para ofrecer una visión más clara de la situación actual.',
    homeShortP2: 'El objetivo es ayudar al paciente a entender mejor su diabetes, ordenar prioridades clínicas y definir un plan de seguimiento adaptado a su perfil.',
    forWhomTitle: 'Para quién es esta valoración',
    forWhomP1: 'Dirigida a personas con diabetes tipo 2, prediabetes o alteraciones de la glucosa que desean comprender mejor su situación actual y revisar su plan de seguimiento.',
    forWhomP2: 'Puede ser especialmente útil si existe diagnóstico reciente, dudas sobre el control metabólico, necesidad de revisar tratamiento, presencia de otros factores de riesgo cardiovascular o interés en ordenar los controles preventivos recomendados.',
    problemTitle: 'El problema habitual',
    problemP1: 'La diabetes tipo 2 no se resume en una cifra de glucosa o hemoglobina glicosilada.',
    problemP2: 'También se relaciona con el peso, la presión arterial, el perfil lipídico, la función renal, el riesgo cardiovascular, los hábitos de vida, la adherencia al tratamiento y los cribados preventivos.',
    problemP3: 'Por eso, en VIDAT realizamos una valoración estructurada que integra todos estos elementos en una misma consulta.',
    includesTitle: 'Qué incluye la valoración',
    includesIntro: 'La valoración parte de la metodología cardiometabólica de VIDAT, adaptada a las necesidades específicas de la diabetes tipo 2.',
    includesIntro2: 'Puede incluir:',
    includesList: [
      'Historia clínica, evolución de la diabetes y antecedentes relevantes.',
      'Revisión del tratamiento actual, adherencia y tolerancia.',
      'Exploración clínica: tensión arterial, peso, perímetro abdominal y valoración dirigida.',
      'Analítica inmediata: glucosa, perfil lipídico y hemoglobina glicosilada.',
      'Valoración de microalbuminuria en orina y creatinina cuando proceda.',
      'Revisión de hábitos de alimentación, actividad física y otros factores de control metabólico.',
      'Orientación sobre controles preventivos recomendados según perfil de riesgo.',
    ],
    obtainTitle: 'Qué obtienes al finalizar',
    obtainList: [
      'Una valoración clara del estado actual de la diabetes tipo 2.',
      'Resultados inmediatos de parámetros metabólicos clave.',
      'Revisión del tratamiento y de posibles áreas de ajuste según criterio médico.',
      'Valoración del riesgo cardiovascular asociado.',
      'Orientación sobre cribados preventivos: función renal, fondo de ojo, podología, ECG y analíticas habituales cuando proceda.',
      'Un plan inicial de seguimiento personalizado y comprensible.',
    ],
    closingTitle: 'Seguimiento, educación y decisiones individualizadas',
    closingP1: 'La diabetes tipo 2 requiere seguimiento, educación sanitaria y decisiones individualizadas.',
    closingP2: 'La Valoración integral de diabetes tipo 2 de VIDAT permite ordenar la información clínica, revisar el control metabólico y definir prioridades de seguimiento con una visión médica global.',
  },
};
